import request from '@utils/request';
import { QueryClient, useQuery } from '@tanstack/react-query';
import { SpaSettingsType } from 'shared-types/SpaPackage';

export function useGetSpaSettings(propertyId?: number) {
  return useQuery({
    queryKey: getSpaSettingsKey(propertyId),
    queryFn: () => getSpaSettings(propertyId),
    staleTime: Infinity,
    cacheTime: Infinity,
    enabled: !!propertyId,
  });
}

export async function getSpaSettings(propertyId?: number) {
  const { data } = await request.get(`${propertyId}/spa-settings`, {
    isPayloadCaseConverterDisabled: true,
  });

  return data as SpaSettingsType;
}

export const getSpaSettingsKey = (propertyId?: number) => ['spaSettings', propertyId];

export const getSpaSettingsPrefetch = (queryClient: QueryClient, propertyId: number) =>
  queryClient.prefetchQuery(getSpaSettingsKey(propertyId), () => getSpaSettings(propertyId), {
    staleTime: Infinity,
    cacheTime: Infinity,
  });
